import { Component } from 'react';
import { connect } from "react-redux";

import { Modal, Button } from 'react-bootstrap'
import { questionIcon } from '../../../img/font_awesome/font_awesome'

import translations from "../../../config/translation/components_translations.json"

const mapStateToProps = state => {
  return {
    language: state.languageReducer ? state.languageReducer : 'ENGLISH'
  };
}

class Confirmation extends Component {
   handleYesClick = (event) => {
      if (event) {
         event.preventDefault();
      }
      this.props.cancelConfirmation();
      this.props.proceedConfirmation();
   }

   handleNoClick = (event) => {
      if (event) {
         event.preventDefault();
      }
      this.props.cancelConfirmation();
   }

   render() {
      let title = ""

      if (this.props.title) {
         title = this.props.title;
      }

      return (
         <Modal show={this.props.show} onHide={this.handleNoClick} size="lg" centered>
            <Modal.Header closeButton >
               <Modal.Title style={{color: '#145A7B'}}>{questionIcon} <span className="sr-only">Confirm to proceed</span> {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{borderTop: '2px solid black', borderBottom: '2px solid black', background: '#145A7B', color: 'white',  fontSize: 20}}>
               {this.props.question}
            </Modal.Body>
            <Modal.Footer>
               <Button variant="primary" onClick={this.handleYesClick}>{translations[this.props.language].yes}</Button>
               <Button variant="secondary" onClick={this.handleNoClick}>{translations[this.props.language].no}</Button>
            </Modal.Footer>
         </Modal>
      )
   }
}

export default connect(mapStateToProps)(Confirmation);